import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { sendAccountBlock } from "../../redux/InwardIteraction/actions";
import InwardXml from "../Nip/InwardInteraction";

const AccountBlock = (props) => {
  const {
    goToFinancialInstitutionList,
    goToAmountBlock,
    sendType,
    accountBlock,
    isLoading,
  } = props;

  const handleAccountBlock1 = () => {
    const payload = {
      type: "balance_enquiry",
    };
    sendType(payload);
  };

  const handleAccountBlock2 = () => {
    const payload = {
      type: "account_block",
    };
    sendType(payload);
  };

  const request = accountBlock && accountBlock.request;
  const response = accountBlock && accountBlock.response;

  return (
    <InwardXml
      prev={goToAmountBlock}
      next={goToFinancialInstitutionList}
      title={"Account Block"}
      request={request}
      response={response}
      optiontitle1={"Balance Enquiry"}
      optiontitle2={"Account Block"}
      handleCase1={handleAccountBlock1}
      handleCase2={handleAccountBlock2}
      isLoading={isLoading}
    />
  );
};

AccountBlock.propTypes = {
  accountBlock: PropTypes.shape({
    request: PropTypes.string,
    response: PropTypes.string,
  }),
  goToAmountBlock: PropTypes.func,
  goToFinancialInstitutionList: PropTypes.func,
  isLoading: PropTypes.bool,
  sendType: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    isLoading: state.inwardInteraction.isLoading,
    sendAccountBlockSuccess: state.inwardInteraction.sendAccountBlockSuccess,
    accountBlock: state.inwardInteraction.sendAccountBlock,
  };
};

const mapDispatchToProps = (dispatch) => ({
  sendType: (payload) => dispatch(sendAccountBlock(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AccountBlock);
